import * as m from "@paraglide/messages"
import type { FormFieldsProps } from "@site-types/sendMail"
import { AttachmentInput } from "../AttachmentInput"
import { Input } from "../Input"
import { useSendMailLang } from "../langContext"
import { RecruitmentSelection } from "../RecruitmentSelection"
import { SponsorshipStartDateSelection } from "../SponsorshipStartDateSelection"
import { TextArea } from "../TextArea"

export const FormFields = ({
  showInputs,
  careerList,
  register,
  errors,
  setValue,
  values,
  messageRules,
  purposeRules,
}: FormFieldsProps) => {
  const lang = useSendMailLang()

  return (
    <div className="border-[#ffffff30] border-t-2">
      {showInputs.formPosition && (
        <RecruitmentSelection
          value={values.position}
          setValue={setValue}
          careerList={careerList ?? []}
        />
      )}

      {showInputs.formName && (
        <Input
          inputLabel={`${m.contact_formName_label({}, { locale: lang })} ${m.contact_form_required({}, { locale: lang })}`}
          toolTip={true}
          inputProps={{
            className: "",
            name: "name",
            placeholder: m.contact_formName_placeholder({}, { locale: lang }),
          }}
          errorMessage={m.contact_formName_validation({}, { locale: lang })}
          register={register}
          errors={errors}
          rules={{ required: m.contact_formName_validation({}, { locale: lang }) }}
        />
      )}

      {showInputs.formCompanyName && (
        <Input
          inputLabel={m.contact_formCompanyName_label({}, { locale: lang })}
          toolTip={false}
          inputProps={{
            className: "",
            name: "companyname",
            placeholder: m.contact_formCompanyName_placeholder({}, { locale: lang }),
          }}
          errorMessage={m.contact_formName_validation({}, { locale: lang })}
          register={register}
          errors={errors}
        />
      )}

      {showInputs.formEmail && (
        <Input
          inputLabel={`${m.contact_formEmail_label({}, { locale: lang })} ${m.contact_form_required({}, { locale: lang })}`}
          toolTip={true}
          inputProps={{
            className: "",
            name: "email",
            placeholder: m.contact_formEmail_placeholder({}, { locale: lang }),
          }}
          errorMessage={m.contact_formEmail_validation({}, { locale: lang })}
          register={register}
          errors={errors}
          rules={{
            required: m.contact_formEmail_validation({}, { locale: lang }),
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: m.contact_formEmail_validation({}, { locale: lang }),
            },
          }}
        />
      )}

      {showInputs.formPhoneNumber && (
        <Input
          inputLabel={m.contact_formPhoneNumber_label({}, { locale: lang })}
          toolTip={false}
          inputProps={{
            className: "",
            type: "text",
            name: "phonenumber",
            maxLength: 20,
            placeholder: m.contact_formPhoneNumber_placeholder({}, { locale: lang }),
          }}
          errorMessage={m.contact_formName_validation({}, { locale: lang })}
          register={register}
          errors={errors}
          rules={{
            setValueAs: (v) => {
              if (typeof v !== "string") return v
              let sanitizedValue = v.replace(/\s+/g, "")
              if (sanitizedValue.charAt(0) !== "+") {
                return sanitizedValue.replace(/[^0-9\s()-]/g, "")
              }
              return sanitizedValue.charAt(0).concat(sanitizedValue.slice(1).replace(/[^0-9\s()-]/g, ""))
            },
          }}
        />
      )}

      {showInputs.formSponsorshipStartDate && (
        <SponsorshipStartDateSelection
          value={values.formSponsorshipStartDate}
          setValue={setValue}
        />
      )}

      {showInputs.formMessage && (
        <TextArea
          inputLabel={`${m.contact_formMessage_label({}, { locale: lang })} ${m.contact_form_required({}, { locale: lang })}`}
          toolTip={true}
          inputProps={{
            id: "form-message",
            name: "message",
            rows: 6,
            placeholder: m.contact_formMessage_placeholder({}, { locale: lang }),
            maxLength: 500,
          }}
          errorMessage={m.contact_formMessage_validation({}, { locale: lang })}
          register={register}
          errors={errors}
          rules={messageRules}
        />
      )}

      {showInputs.formPurpose && (
        <TextArea
          inputLabel={`${m.contact_formPurpose_label({}, { locale: lang })} ${m.contact_form_required({}, { locale: lang })}`}
          toolTip={true}
          inputProps={{
            id: "form-Purpose",
            name: "purpose",
            rows: 6,
            placeholder: m.contact_formMessage_placeholder({}, { locale: lang }),
            maxLength: 500,
          }}
          errorMessage={m.contact_formMessage_validation({}, { locale: lang })}
          register={register}
          errors={errors}
          rules={purposeRules}
        />
      )}

      {showInputs.formAttachments && (
        <AttachmentInput
          toolTip={true}
          errorMessage={m.contact_formAttachment_validation({}, { locale: lang })}
          attachments={values.attachments}
          setValue={setValue}
          errors={errors}
        />
      )}
    </div>
  )
}
